export const button = {
    slots: {
        base: [
            'rounded-[calc(var(--ui-radius)*1)] font-medium inline-flex items-center focus:outline-hidden disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75',
            'transition-colors',
        ],
        label: 'truncate',
        leadingIcon: 'shrink-0',
        leadingAvatar: 'shrink-0',
        leadingAvatarSize: '',
        trailingIcon: 'shrink-0',
    },
    variants: {
        buttonGroup: {
            horizontal:
                'not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none',
            vertical:
                'not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none',
        },
        color: {
            white: {
                solid:
                    'shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 text-gray-900 dark:text-white bg-white hover:bg-gray-50 disabled:bg-white aria-disabled:bg-white dark:bg-gray-900 dark:hover:bg-gray-800/50 dark:disabled:bg-gray-900 dark:aria-disabled:bg-gray-900 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
                ghost:
                    'text-gray-900 dark:text-white hover:bg-white dark:hover:bg-gray-900 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
            },
            gray: {
                solid:
                    'shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 text-gray-700 dark:text-gray-200 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-50 aria-disabled:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700/50 dark:disabled:bg-gray-800 dark:aria-disabled:bg-gray-800 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
                ghost:
                    'text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
                link:
                    'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 underline-offset-4 hover:underline focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
            },
            black: {
                solid:
                    'shadow-sm text-white dark:text-gray-900 bg-gray-900 hover:bg-gray-800 disabled:bg-gray-900 aria-disabled:bg-gray-900 dark:bg-white dark:hover:bg-gray-100 dark:disabled:bg-white dark:aria-disabled:bg-white focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
                link:
                    'text-gray-900 dark:text-white underline-offset-4 hover:underline focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
            },
            rose: {
                solid: 'bg-rose-600 dark:bg-rose-400',
                link:
                    'text-rose-900 dark:text-white underline-offset-4 hover:underline focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
            },
        },
        variant: {
            solid:
                'shadow-sm text-white dark:text-gray-900 bg-{color}-500 hover:bg-{color}-600 disabled:bg-{color}-500 aria-disabled:bg-{color}-500 dark:bg-{color}-400 dark:hover:bg-{color}-500 dark:disabled:bg-{color}-400 dark:aria-disabled:bg-{color}-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-{color}-500 dark:focus-visible:outline-{color}-400',
            outline:
                'ring-1 ring-inset ring-current text-{color}-500 dark:text-{color}-400 hover:bg-{color}-50 disabled:bg-transparent aria-disabled:bg-transparent dark:hover:bg-{color}-950 dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400',
            soft:
                'text-{color}-500 dark:text-{color}-400 bg-{color}-100 hover:bg-{color}-100 disabled:bg-{color}-50 aria-disabled:bg-{color}-50 dark:bg-{color}-950 dark:hover:bg-{color}-900 dark:disabled:bg-{color}-950 dark:aria-disabled:bg-{color}-950 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400',
            ghost:
                'text-{color}-500 dark:text-{color}-400 hover:bg-{color}-50 disabled:bg-transparent aria-disabled:bg-transparent dark:hover:bg-{color}-950 dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400',
            link:
                'text-{color}-500 hover:text-{color}-600 disabled:text-{color}-500 aria-disabled:text-{color}-500 dark:text-{color}-400 dark:hover:text-{color}-500 dark:disabled:text-{color}-400 dark:aria-disabled:text-{color}-400 underline-offset-4 hover:underline focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400',
        },
        size: {
            xs: {
                base: 'px-2 py-1 text-xs gap-1',
                leadingIcon: 'size-4',
                leadingAvatarSize: '3xs',
                trailingIcon: 'size-4',
            },
            sm: {
                base: 'px-2.5 py-1.5 text-xs gap-1.5',
                leadingIcon: 'size-4',
                leadingAvatarSize: '3xs',
                trailingIcon: 'size-4',
            },
            md: {
                base: 'px-2.5 py-1.5 text-sm gap-1.5',
                leadingIcon: 'size-5',
                leadingAvatarSize: '2xs',
                trailingIcon: 'size-5',
            },
            lg: {
                base: 'px-3 py-2 text-sm gap-2',
                leadingIcon: 'size-5',
                leadingAvatarSize: '2xs',
                trailingIcon: 'size-5',
            },
            xl: {
                base: 'px-3 py-2 text-base gap-2',
                leadingIcon: 'size-6',
                leadingAvatarSize: 'xs',
                trailingIcon: 'size-6',
            },
        },
        block: {
            true: {
                base: 'w-full justify-center',
                trailingIcon: 'ms-auto',
            },
        },
        square: {
            true: '',
        },
        leading: {
            true: '',
        },
        trailing: {
            true: '',
        },
        loading: {
            icon: 'i-lucide-repeat-2',
            true: '',
        },
    },
    compoundVariants: [
        {
            color: 'rose',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-rose) hover:bg-(--ui-rose)/75 disabled:bg-(--ui-rose) aria-disabled:bg-(--ui-rose) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-rose)',
        },
        {
            color: 'rose',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-rose)/50 text-(--ui-rose) hover:bg-(--ui-rose)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-rose)',
        },
        {
            color: 'rose',
            variant: 'soft',
            class:
                'text-(--ui-rose) bg-(--ui-rose)/10 hover:bg-(--ui-rose)/20 focus-visible:bg-(--ui-rose)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-rose)',
        },
        {
            color: 'rose',
            variant: 'link',
            class:
                'text-(--ui-rose) hover:text-(--ui-rose)/75 disabled:text-(--ui-rose) aria-disabled:text-(--ui-rose) focus-visible:underline focus-visible:decoration-(--ui-rose) focus-visible:decoration-2',
        },
        {
            color: 'rose',
            variant: 'ghost',
            class:
                'text-[var(--ui-rose)] hover:bg-[var(--ui-rose)]/10 focus-visible:bg-[var(--ui-rose)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            color: 'teal',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-teal) hover:bg-(--ui-teal)/75 disabled:bg-(--ui-teal) aria-disabled:bg-(--ui-teal) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-teal)',
        },
        {
            color: 'teal',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-teal)/50 text-(--ui-teal) hover:bg-(--ui-teal)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-teal)',
        },
        {
            color: 'teal',
            variant: 'soft',
            class:
                'text-(--ui-teal) bg-(--ui-teal)/10 hover:bg-(--ui-teal)/20 focus-visible:bg-(--ui-teal)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-teal)',
        },
        {
            color: 'teal',
            variant: 'link',
            class:
                'text-(--ui-teal) hover:text-(--ui-teal)/75 disabled:text-(--ui-teal) aria-disabled:text-(--ui-teal) focus-visible:underline focus-visible:decoration-(--ui-teal) focus-visible:decoration-2',
        },
        {
            color: 'teal',
            variant: 'ghost',
            class:
                'text-[var(--ui-teal)] hover:bg-[var(--ui-teal)]/10 focus-visible:bg-[var(--ui-teal)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },

        {
            color: 'primary',
            variant: 'outline',
            class:
                'ring ring-inset ring-[var(--ui-primary)]/50 text-[var(--ui-primary)] hover:bg-[var(--ui-primary)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-[var(--ui-primary)]',
        },
        {
            color: 'primary',
            variant: 'soft',
            class:
                'text-[var(--ui-primary)] bg-[var(--ui-primary)]/10 hover:bg-[var(--ui-primary)]/15 focus-visible:bg-[var(--ui-primary)]/15 disabled:bg-[var(--ui-primary)]/10 aria-disabled:bg-[var(--ui-primary)]/10',
        },
        {
            color: 'primary',
            variant: 'subtle',
            class:
                'text-[var(--ui-primary)] ring ring-inset ring-[var(--ui-primary)]/25 bg-[var(--ui-primary)]/10 hover:bg-[var(--ui-primary)]/15 disabled:bg-[var(--ui-primary)]/10 aria-disabled:bg-[var(--ui-primary)]/10 focus-visible:ring-2 focus-visible:ring-[var(--ui-primary)]',
        },
        {
            color: 'primary',
            variant: 'ghost',
            class:
                'text-[var(--ui-primary)] hover:bg-[var(--ui-primary)]/10 focus-visible:bg-[var(--ui-primary)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            color: 'primary',
            variant: 'link',
            class:
                'text-[var(--ui-primary)] hover:text-[var(--ui-primary)]/75 disabled:text-[var(--ui-primary)] aria-disabled:text-[var(--ui-primary)] focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--ui-primary)]',
        },
        {
            color: 'neutral',
            variant: 'solid',
            class:
                'text-[var(--ui-bg)] bg-[var(--ui-bg-inverted)] hover:bg-[var(--ui-bg-inverted)]/90 disabled:bg-[var(--ui-bg-inverted)] aria-disabled:bg-[var(--ui-bg-inverted)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--ui-border-inverted)]',
        },
        {
            color: 'neutral',
            variant: 'outline',
            class:
                'ring ring-inset ring-[var(--ui-border-accented)] text-[var(--ui-text)] bg-[var(--ui-bg)] hover:bg-[var(--ui-bg-elevated)] disabled:bg-[var(--ui-bg)] aria-disabled:bg-[var(--ui-bg)] focus-visible:ring-2 focus-visible:ring-[var(--ui-border-inverted)]',
        },
        {
            color: 'neutral',
            variant: 'soft',
            class:
                'text-[var(--ui-text)] bg-[var(--ui-bg-elevated)] hover:bg-[var(--ui-bg-accented)]/75 focus-visible:bg-[var(--ui-bg-accented)]/75 disabled:bg-[var(--ui-bg-elevated)] aria-disabled:bg-[var(--ui-bg-elevated)]',
        },
        {
            color: 'neutral',
            variant: 'subtle',
            class:
                'ring ring-inset ring-[var(--ui-border-accented)] text-[var(--ui-text)] bg-[var(--ui-bg-elevated)] hover:bg-[var(--ui-bg-accented)]/75 disabled:bg-[var(--ui-bg-elevated)] aria-disabled:bg-[var(--ui-bg-elevated)] focus-visible:ring-2 focus-visible:ring-[var(--ui-border-inverted)]',
        },
        {
            color: 'neutral',
            variant: 'ghost',
            class:
                'text-[var(--ui-text)] hover:bg-[var(--ui-bg-elevated)] focus-visible:bg-[var(--ui-bg-elevated)] hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent',
        },
        {
            color: 'neutral',
            variant: 'link',
            class:
                'text-[var(--ui-text-muted)] hover:text-[var(--ui-text)] disabled:text-[var(--ui-text-muted)] aria-disabled:text-[var(--ui-text-muted)] focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-[var(--ui-border-inverted)]',
        },
        {
            color: 'indigo',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-indigo) hover:bg-(--ui-indigo)/75 disabled:bg-(--ui-indigo) aria-disabled:bg-(--ui-indigo) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-indigo)',
        },
        {
            color: 'indigo',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-indigo)/50 text-(--ui-indigo) hover:bg-(--ui-indigo)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-indigo)',
        },
        {
            color: 'indigo',
            variant: 'soft',
            class:
                'text-(--ui-indigo) bg-(--ui-indigo)/10 hover:bg-(--ui-indigo)/20 focus-visible:bg-(--ui-indigo)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-indigo)',
        },
        {
            color: 'indigo',
            variant: 'link',
            class:
                'text-(--ui-indigo) hover:text-(--ui-indigo)/75 disabled:text-(--ui-indigo) aria-disabled:text-(--ui-indigo) focus-visible:underline focus-visible:decoration-(--ui-indigo) focus-visible:decoration-2',
        },
        {
            color: 'indigo',
            variant: 'ghost',
            class:
                'text-[var(--ui-indigo)] hover:bg-[var(--ui-indigo)]/10 focus-visible:bg-[var(--ui-indigo)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            color: 'violet',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-violet) hover:bg-(--ui-violet)/75 disabled:bg-(--ui-violet) aria-disabled:bg-(--ui-violet) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-violet)',
        },
        {
            color: 'violet',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-violet)/50 text-(--ui-violet) hover:bg-(--ui-violet)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-violet)',
        },
        {
            color: 'violet',
            variant: 'soft',
            class:
                'text-(--ui-violet) bg-(--ui-violet)/10 hover:bg-(--ui-violet)/20 focus-visible:bg-(--ui-violet)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-violet)',
        },
        {
            color: 'violet',
            variant: 'link',
            class:
                'text-(--ui-violet) hover:text-(--ui-violet)/75 disabled:text-(--ui-violet) aria-disabled:text-(--ui-violet) focus-visible:underline focus-visible:decoration-(--ui-violet) focus-visible:decoration-2',
        },
        {
            color: 'violet',
            variant: 'ghost',
            class:
                'text-[var(--ui-violet)] hover:bg-[var(--ui-violet)]/10 focus-visible:bg-[var(--ui-violet)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            color: 'pink',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-pink) hover:bg-(--ui-pink)/75 disabled:bg-(--ui-pink) aria-disabled:bg-(--ui-pink) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-pink)',
        },
        {
            color: 'pink',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-pink)/50 text-(--ui-pink) hover:bg-(--ui-pink)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-pink)',
        },
        {
            color: 'pink',
            variant: 'soft',
            class:
                'text-(--ui-pink) bg-(--ui-pink)/10 hover:bg-(--ui-pink)/20 focus-visible:bg-(--ui-pink)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-pink)',
        },
        {
            color: 'pink',
            variant: 'link',
            class:
                'text-(--ui-pink) hover:text-(--ui-pink)/75 disabled:text-(--ui-pink) aria-disabled:text-(--ui-pink) focus-visible:underline focus-visible:decoration-(--ui-pink) focus-visible:decoration-2',
        },
        {
            color: 'pink',
            variant: 'ghost',
            class:
                'text-[var(--ui-pink)] hover:bg-[var(--ui-pink)]/10 focus-visible:bg-[var(--ui-pink)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            color: 'emerald',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-emerald) hover:bg-(--ui-emerald)/75 disabled:bg-(--ui-emerald) aria-disabled:bg-(--ui-emerald) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-emerald)',
        },
        {
            color: 'emerald',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-emerald)/50 text-(--ui-emerald) hover:bg-(--ui-emerald)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-emerald)',
        },
        {
            color: 'emerald',
            variant: 'soft',
            class:
                'text-(--ui-emerald) bg-(--ui-emerald)/10 hover:bg-(--ui-emerald)/20 focus-visible:bg-(--ui-emerald)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-emerald)',
        },
        {
            color: 'emerald',
            variant: 'link',
            class:
                'text-(--ui-emerald) hover:text-(--ui-emerald)/75 disabled:text-(--ui-emerald) aria-disabled:text-(--ui-emerald) focus-visible:underline focus-visible:decoration-(--ui-emerald) focus-visible:decoration-2',
        },
        {
            color: 'emerald',
            variant: 'ghost',
            class:
                'text-[var(--ui-emerald)] hover:bg-[var(--ui-emerald)]/10 focus-visible:bg-[var(--ui-emerald)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            color: 'orange',
            variant: 'solid',
            class:
                'text-(--ui-bg) bg-(--ui-orange) hover:bg-(--ui-orange)/75 disabled:bg-(--ui-orange) aria-disabled:bg-(--ui-orange) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-orange)',
        },
        {
            color: 'orange',
            variant: 'outline',
            class:
                'ring ring-inset ring-(--ui-orange)/50 text-(--ui-orange) hover:bg-(--ui-orange)/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-(--ui-orange)',
        },
        {
            color: 'orange',
            variant: 'soft',
            class:
                'text-(--ui-orange) bg-(--ui-orange)/10 hover:bg-(--ui-orange)/20 focus-visible:bg-(--ui-orange)/20 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-orange)',
        },
        {
            color: 'orange',
            variant: 'link',
            class:
                'text-(--ui-orange) hover:text-(--ui-orange)/75 disabled:text-(--ui-orange) aria-disabled:text-(--ui-orange) focus-visible:underline focus-visible:decoration-(--ui-orange) focus-visible:decoration-2',
        },
        {
            color: 'orange',
            variant: 'ghost',
            class:
                'text-[var(--ui-orange)] hover:bg-[var(--ui-orange)]/10 focus-visible:bg-[var(--ui-orange)]/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent',
        },
        {
            size: 'xs',
            square: true,
            class: 'p-1',
        },
        {
            size: 'sm',
            square: true,
            class: 'p-1.5',
        },
        {
            size: 'md',
            square: true,
            class: 'p-1.5',
        },
        {
            size: 'lg',
            square: true,
            class: 'p-2',
        },
        {
            size: 'xl',
            square: true,
            class: 'p-2',
        },
        {
            loading: true,
            leading: true,
            class: {
                leadingIcon: 'animate-spin',
            },
        },
        {
            loading: true,
            leading: false,
            trailing: true,
            class: {
                trailingIcon: 'animate-spin',
            },
        },
    ],
    defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
    },
}
